import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectTripCancellationStep, makeSelectTripCancellationStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
} from './actions';
import {
  emailMedicalTravelDocument,
} from '../../FastCover/actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { AdditionalList } from './components/Additional';
import { InsuredList } from './components/AddInsured';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import AsyncButtonSendMail from '../../../components/AsyncButtonSendMail/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import HelpText from '../../../components/HelpText';
import { stepTripCancellationLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly } from '../../../utils/validation/validator';

export class TripCancellationStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onLossInformationItemsChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsTravelCancellation', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onLossInformationItemsChangeV2 = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsForAirlineReissue', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onLossInformationItemsChangeV3 = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsForReinstateFrequent', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredTravelCancellationChange = (data) => {
    this.props.onFormDataChange('form.insuredsTravelCancellation', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredAirlineReissue = (data) => {
    this.props.onFormDataChange('form.insuredsAirlineReissue', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredReinstateFrequent = (data) => {
    this.props.onFormDataChange('form.insuredsReinstateFrequent', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripCancellation = (propertyName) => (event) => {
    const { reasonsForTripCancellation } = this.props.form;
    const reasons = !!reasonsForTripCancellation && typeof reasonsForTripCancellation.toJS === 'function'
      ? reasonsForTripCancellation.toJS()
      : reasonsForTripCancellation || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };


  renderAdditionalItems() {
    const { lossInformationItemsTravelCancellation } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItemsTravelCancellation);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onLossInformationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderAirlineReissueAdditionalItems() {
    const { lossInformationItemsForAirlineReissue } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItemsForAirlineReissue);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onLossInformationItemsChangeV2}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderReinstateFrequentAdditionalItems() {
    const { lossInformationItemsForReinstateFrequent } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItemsForReinstateFrequent);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onLossInformationItemsChangeV3}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredsTravelCancellation() {
    const { insuredsTravelCancellation } = this.props.form;
    const newInsureds = this.appendIds(insuredsTravelCancellation);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTravelCancellationChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderInsuredsAirlineReissue() {
    const { insuredsAirlineReissue } = this.props.form;
    const newInsureds = this.appendIds(insuredsAirlineReissue);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredAirlineReissue}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderReinstateFrequent() {
    const { insuredsReinstateFrequent } = this.props.form;
    const newInsureds = this.appendIds(insuredsReinstateFrequent);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredReinstateFrequent}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTripCancellation() {
    const {
      tripCancellation,
      areYouClaimingForAirlineReissueOrCancellationFees,
      areYouClaimingForReinstateFrequentTravelerAwards,
      areYouCancellingTheTripDueToMedicalReasons,
      schoolName,
      // reasonsForTripCancellation,
      companyNameTravelCancellation,
      addressTravelCancellation,
      cityTravelCancellation,
      stateTravelCancellation,
      zipCodeTravelCancellation,
      contactTravelCancellation,
      phoneNumberTravelCancellation,
      includedInPackageTravelCancellation,
      dateTravelCancellation,
      reasonForTravelCancellation,
      nameOfPersonHavingSicknessTravelCancellation,
      dateOfBirthTravelCancellation,
      relationshipToClaimantTravelCancellation,
      dateSicknessOrInjuryBeganTravelCancellation,
      dateEndedTravelCancellation,
      natureOfSicknessOrInjuryTravelCancellation,
      fromDateTravelCancellation,
      toDateTravelCancellation,
      enableTime,
      dateOfInitialPaymentDepositTravelCancellation,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    // const reasonsForTripCancellations = !!reasonsForTripCancellation && typeof reasonsForTripCancellation.toJS === 'function'
    //   ? reasonsForTripCancellation.toJS()
    //   : reasonsForTripCancellation || [];
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    const isReadOnly = submitted || isSummary;
    return (
      tripCancellation === 'true' && (
        <div>
          <div className={'ml-3 row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForAirlineReissueOrCancellationFees} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForAirlineReissueOrCancellationFees === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForAirlineReissueOrCancellationFees')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForAirlineReissueOrCancellationFees === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForAirlineReissueOrCancellationFees')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-3 row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForReinstateFrequentTravelerAwards} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForReinstateFrequentTravelerAwards === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForReinstateFrequentTravelerAwards')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForReinstateFrequentTravelerAwards === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForReinstateFrequentTravelerAwards')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredsTravelCancellation()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasons === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasons === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolName"
                      type="text"
                      onChange={this.handleChange('form.schoolName')}
                      value={schoolName}
                      disabled={isReadOnly}
                    />
              </div>
            </div>            
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameTravelCancellation}
                  fieldName={messages.companyNameTravelInterruption}
                  >
                    <Textbox
                      name="companyNameTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.companyNameTravelCancellation')}
                      value={companyNameTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressTravelCancellation}
                  fieldName={messages.addressTravelInterruption}
                  >
                    <Textbox
                      name="addressTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.addressTravelCancellation')}
                      value={addressTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityTravelCancellation}
                  fieldName={messages.cityTravelInterruption}
                  >
                    <Textbox
                      name="cityTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.cityTravelCancellation')}
                      value={cityTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateTravelCancellation}
                  fieldName={messages.stateTravelInterruption}
                  >
                    <Textbox
                      name="stateTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.stateTravelCancellation')}
                      value={stateTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeTravelCancellation}
                  fieldName={messages.zipCodeTravelInterruption}
                  >
                    <Textbox
                      name="zipCodeTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.zipCodeTravelCancellation')}
                      value={zipCodeTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactTravelCancellation}
                  fieldName={messages.contactTravelInterruption}
                  >
                    <Textbox
                      name="contactTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.contactTravelCancellation')}
                      value={contactTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberTravelCancellation}
                  fieldName={messages.phoneNumber}
                  >
                    <Textbox
                      name="phoneNumberTravelCancellation"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberTravelCancellation')}
                      value={phoneNumberTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumber}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDepositTravelCancellation}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDepositTravelCancellation')}
                    value={dateOfInitialPaymentDepositTravelCancellation}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="includedInPackageTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageTravelCancellation')}
                  value={includedInPackageTravelCancellation}
                  isSummary={isSummary}
                />
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformation} />
            </PageSectionHeader>
            {this.renderAdditionalItems()}
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTravelCancellation"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTravelCancellation}
                  fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTravelCancellation')}
                    value={dateTravelCancellation}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="reasonForCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reasonForTravelCancellation}
                  fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForTravelCancellation')}
                      value={reasonForTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-5 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                </PageSectionHeader>
                <Textbox
                      name="nameOfPersonHavingSicknessTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSicknessTravelCancellation')}
                      value={nameOfPersonHavingSicknessTravelCancellation}
                      disabled={isReadOnly}
                    />
              </div>
              <div className={'col-sm-3 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateOfBirth} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfBirthTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfBirthTravelCancellation')}
                  value={dateOfBirthTravelCancellation}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.relationshipToClaimant} />
                </PageSectionHeader>
                <Textbox
                  name="relationshipToClaimantTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.relationshipToClaimantTravelCancellation')}
                  value={relationshipToClaimantTravelCancellation}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateSicknessOrInjuryBeganTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTravelCancellation')}
                  value={dateSicknessOrInjuryBeganTravelCancellation}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateEnded} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateEndedTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateEndedTravelCancellation')}
                  value={dateEndedTravelCancellation}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="natureOfSicknessOrInjuryTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.natureOfSicknessOrInjuryTravelCancellation')}
                  value={natureOfSicknessOrInjuryTravelCancellation}
                  isSummary={isSummary}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.periodOfHospitalization} />
                </PageSectionHeader>
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.fromDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="fromDateTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.fromDateTravelCancellation')}
                  value={fromDateTravelCancellation}
                />
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.toDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="toDateTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.toDateTravelCancellation')}
                  value={toDateTravelCancellation}
                />
              </div>
              <div className={'form-group col-sm-6'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  renderAirlineReissueOrCancellationFees() {
    const {
      areYouClaimingForAirlineReissueOrCancellationFees,
      areYouCancellingTheTripDueToMedicalReasonsAirlineReissue,
      schoolNameAirlineReissue,
      // reasonsForAirlineReissue,
      companyNameForAirlineReissue,
      addressForAirlineReissue,
      cityForAirlineReissue,
      stateForAirlineReissue,
      zipCodeForAirlineReissue,
      contactForAirlineReissue,
      phoneNumberForAirlineReissue,
      includedInPackageForAirlineReissue,
      dateForAirlineReissue,
      reasonForAirlineReissue,
      nameOfPersonHavingSicknessForAirlineReissue,
      dateOfBirthForAirlineReissue,
      relationshipToClaimantForAirlineReissue,
      dateSicknessOrInjuryBeganForAirlineReissue,
      dateEndedForAirlineReissue,
      natureOfSicknessOrInjuryForAirlineReissue,
      fromDateForAirlineReissue,
      toDateForAirlineReissue,
      enableTime,
      dateOfInitialPaymentDepositAirlineReissue,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    // const reasonsForTripCancellations = !!reasonsForAirlineReissue && typeof reasonsForAirlineReissue.toJS === 'function'
    //   ? reasonsForAirlineReissue.toJS()
    //   : reasonsForAirlineReissue || [];
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForAirlineReissueOrCancellationFees === 'true' && (
        <div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderInsuredsAirlineReissue()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasonsAirlineReissue === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasonsAirlineReissue')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasonsAirlineReissue === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasonsAirlineReissue')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolName"
                      type="text"
                      onChange={this.handleChange('form.schoolNameAirlineReissue')}
                      value={schoolNameAirlineReissue}
                      disabled={isReadOnly}
                    />
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameForAirlineReissue}
                  fieldName={messages.companyNameTravelInterruption}
                  >
                    <Textbox
                      name="companyNameTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.companyNameForAirlineReissue')}
                      value={companyNameForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressForAirlineReissue}
                  fieldName={messages.addressTravelInterruption}
                  >
                    <Textbox
                      name="addressTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.addressForAirlineReissue')}
                      value={addressForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityForAirlineReissue}
                  fieldName={messages.cityTravelInterruption}
                  >
                    <Textbox
                      name="cityTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.cityForAirlineReissue')}
                      value={cityForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateForAirlineReissue}
                  fieldName={messages.stateTravelInterruption}
                  >
                    <Textbox
                      name="stateTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.stateForAirlineReissue')}
                      value={stateForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeForAirlineReissue}
                  fieldName={messages.zipCodeTravelInterruption}
                  >
                    <Textbox
                      name="zipCodeTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.zipCodeForAirlineReissue')}
                      value={zipCodeForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactForAirlineReissue}
                  fieldName={messages.contactTravelInterruption}
                  >
                    <Textbox
                      name="contactTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.contactForAirlineReissue')}
                      value={contactForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberForAirlineReissue}
                  fieldName={messages.phoneNumberTravelInterruption}
                  >
                    <Textbox
                      name="phoneNumberTravelCancellation"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberForAirlineReissue')}
                      value={phoneNumberForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumberTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDepositAirlineReissue}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDepositAirlineReissue')}
                    value={dateOfInitialPaymentDepositAirlineReissue}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="includedInPackageTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageForAirlineReissue')}
                  value={includedInPackageForAirlineReissue}
                  isSummary={isSummary}
                />
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformation} />
            </PageSectionHeader>
            {this.renderAirlineReissueAdditionalItems()}
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTravelCancellation"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateForAirlineReissue}
                  fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateForAirlineReissue')}
                    value={dateForAirlineReissue}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="reasonForCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reasonForAirlineReissue}
                  fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForAirlineReissue')}
                      value={reasonForAirlineReissue}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-5 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                </PageSectionHeader>
                <Textbox
                      name="nameOfPersonHavingSicknessTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSicknessForAirlineReissue')}
                      value={nameOfPersonHavingSicknessForAirlineReissue}
                      disabled={isReadOnly}
                    />
              </div>
              <div className={'col-sm-3 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateOfBirth} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfBirthTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfBirthForAirlineReissue')}
                  value={dateOfBirthForAirlineReissue}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.relationshipToClaimant} />
                </PageSectionHeader>
                <Textbox
                  name="relationshipToClaimantTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.relationshipToClaimantForAirlineReissue')}
                  value={relationshipToClaimantForAirlineReissue}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateSicknessOrInjuryBeganTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganForAirlineReissue')}
                  value={dateSicknessOrInjuryBeganForAirlineReissue}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateEnded} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateEndedTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateEndedForAirlineReissue')}
                  value={dateEndedForAirlineReissue}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="natureOfSicknessOrInjuryTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.natureOfSicknessOrInjuryForAirlineReissue')}
                  value={natureOfSicknessOrInjuryForAirlineReissue}
                  isSummary={isSummary}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.periodOfHospitalization} />
                </PageSectionHeader>
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.fromDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="fromDateTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.fromDateForAirlineReissue')}
                  value={fromDateForAirlineReissue}
                />
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.toDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="toDateTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.toDateForAirlineReissue')}
                  value={toDateForAirlineReissue}
                />
              </div>
              <div className={'form-group col-sm-6'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  renderReinstateFrequentTravelerAwards() {
    const {
      areYouClaimingForReinstateFrequentTravelerAwards,
      areYouCancellingTheTripDueToMedicalReasonsReinstateFrequent,
      schoolNameReinstateFrequent,
      // reasonsForReinstateFrequent,
      companyNameForReinstateFrequent,
      addressForReinstateFrequent,
      cityForReinstateFrequent,
      stateForReinstateFrequent,
      zipCodeForReinstateFrequent,
      contactForReinstateFrequent,
      phoneNumberForReinstateFrequent,
      includedInPackageForReinstateFrequent,
      dateForReinstateFrequent,
      reasonForReinstateFrequent,
      nameOfPersonHavingSicknessForReinstateFrequent,
      dateOfBirthForReinstateFrequent,
      relationshipToClaimantForReinstateFrequent,
      dateSicknessOrInjuryBeganForReinstateFrequent,
      dateEndedForReinstateFrequent,
      natureOfSicknessOrInjuryForReinstateFrequent,
      fromDateForReinstateFrequent,
      toDateForReinstateFrequent,
      enableTime,
      dateOfInitialPaymentDepositReinstateFrequent,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    // const reasonsForTripCancellations = !!reasonsForReinstateFrequent && typeof reasonsForReinstateFrequent.toJS === 'function'
    //   ? reasonsForReinstateFrequent.toJS()
    //   : reasonsForReinstateFrequent || [];
    const { isSummary, submitted } = this.props;
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForReinstateFrequentTravelerAwards === 'true' && (
        <div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.insureds} />
            </PageSectionHeader>
            {this.renderReinstateFrequent()}
          </div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasonsReinstateFrequent === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasonsReinstateFrequent === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.schoolName} />
                </PageSectionHeader>
                    <Textbox
                      name="schoolName"
                      type="text"
                      onChange={this.handleChange('form.schoolNameReinstateFrequent')}
                      value={schoolNameReinstateFrequent}
                      disabled={isReadOnly}
                    />
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplier} />
              </PageSectionHeader>
            </div>
            <div className={'row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyNameTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyNameForReinstateFrequent}
                  fieldName={messages.companyNameTravelInterruption}
                  >
                    <Textbox
                      name="companyNameTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.companyNameForReinstateFrequent')}
                      value={companyNameForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.companyNameTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="addressTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={addressForReinstateFrequent}
                  fieldName={messages.addressTravelInterruption}
                  >
                    <Textbox
                      name="addressTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.addressForReinstateFrequent')}
                      value={addressForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.addressTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="cityTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={cityForReinstateFrequent}
                  fieldName={messages.cityTravelInterruption}
                  >
                    <Textbox
                      name="cityTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.cityForReinstateFrequent')}
                      value={cityForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.cityTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="stateTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={stateForReinstateFrequent}
                  fieldName={messages.stateTravelInterruption}
                  >
                    <Textbox
                      name="stateTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.stateForReinstateFrequent')}
                      value={stateForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.stateTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="zipCodeTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={zipCodeForReinstateFrequent}
                  fieldName={messages.zipCodeTravelInterruption}
                  >
                    <Textbox
                      name="zipCodeTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.zipCodeForReinstateFrequent')}
                      value={zipCodeForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.zipCodeTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="contactTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={contactForReinstateFrequent}
                  fieldName={messages.contactTravelInterruption}
                  >
                    <Textbox
                      name="contactTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.contactForReinstateFrequent')}
                      value={contactForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.contactTravelInterruption}
                      />
                    </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="phoneNumberTravelCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={phoneNumberForReinstateFrequent}
                  fieldName={messages.phoneNumberTravelInterruption}
                  >
                    <Textbox
                      name="phoneNumberTravelCancellation"
                      type="text"
                      onChange={this.handleChangePhoneNumber('form.phoneNumberForReinstateFrequent')}
                      value={phoneNumberForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.phoneNumberTravelInterruption}
                      />
                    </ErrorMessage>
                  </Validate>
              </div>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="dateOfInitialPaymentDeposit"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateOfInitialPaymentDepositReinstateFrequent}
                  fieldName={messages.dateOfInitialPaymentDeposit}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateOfInitialPaymentDepositReinstateFrequent')}
                    value={dateOfInitialPaymentDepositReinstateFrequent}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfInitialPaymentDeposit}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.includedInPackage} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="includedInPackageTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.includedInPackageForReinstateFrequent')}
                  value={includedInPackageForReinstateFrequent}
                  isSummary={isSummary}
                />
              </div>
            </div>
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformation} />
            </PageSectionHeader>
            {this.renderReinstateFrequentAdditionalItems()}
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTravelCancellation"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateForReinstateFrequent}
                  fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateForReinstateFrequent')}
                    value={dateForReinstateFrequent}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="reasonForCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reasonForReinstateFrequent}
                  fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForReinstateFrequent')}
                      value={reasonForReinstateFrequent}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>               
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-5 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                </PageSectionHeader>
                <Textbox
                      name="nameOfPersonHavingSicknessTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSicknessForReinstateFrequent')}
                      value={nameOfPersonHavingSicknessForReinstateFrequent}
                      disabled={isReadOnly}
                    />
              </div>
              <div className={'col-sm-3 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateOfBirth} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfBirthTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfBirthForReinstateFrequent')}
                  value={dateOfBirthForReinstateFrequent}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.relationshipToClaimant} />
                </PageSectionHeader>
                <Textbox
                  name="relationshipToClaimantTravelCancellation"
                  type="text"
                  onChange={this.handleChange('form.relationshipToClaimantForReinstateFrequent')}
                  value={relationshipToClaimantForReinstateFrequent}
                  disabled={isReadOnly}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateSicknessOrInjuryBeganForReinstateFrequent"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganForReinstateFrequent')}
                  value={dateSicknessOrInjuryBeganForReinstateFrequent}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateEnded} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateEndedTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateEndedForReinstateFrequent')}
                  value={dateEndedForReinstateFrequent}
                />
              </div>
              <div className={'col-sm-4 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                </PageSectionHeader>
                <TextArea
                  disabled={isReadOnly}
                  name="natureOfSicknessOrInjuryForReinstateFrequent"
                  type="text"
                  onChange={this.handleChange('form.natureOfSicknessOrInjuryForReinstateFrequent')}
                  value={natureOfSicknessOrInjuryForReinstateFrequent}
                  isSummary={isSummary}
                />
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.periodOfHospitalization} />
                </PageSectionHeader>
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.fromDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="fromDateTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.fromDateForReinstateFrequent')}
                  value={fromDateForReinstateFrequent}
                />
              </div>
              <div className={'form-group col-sm-3'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.toDate} />
                </PageSectionHeader>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="toDateTravelCancellation"
                  type="text"
                  onDayChange={this.handleDayChange('form.toDateForReinstateFrequent')}
                  value={toDateForReinstateFrequent}
                />
              </div>
              <div className={'form-group col-sm-6'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  render() {
    const {
      tripCancellation,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderTravelCancellation = !!stepTripCancellationLookup.tripCancellation.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {isRenderTravelCancellation &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.tripCancellation} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={tripCancellation === 'true'}
                    onChange={this.handleChange('form.tripCancellation')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={tripCancellation === 'false'}
                    onChange={this.handleChange('form.tripCancellation')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelCancellation && this.renderTripCancellation()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

TripCancellationStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  sendPhysicianEmail: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectTripCancellationStep(),
  errors: makeSelectTripCancellationStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  sendPhysicianEmail: () => dispatch(emailMedicalTravelDocument()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'tripCancellationStep', reducer });

export default compose(
  withReducer,
  withConnect
)(TripCancellationStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.TripCancellationStep/index.js